if (!customElements.get('project-list')) {
  customElements.define(
    'project-list',
    class ProjectList extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          form: '#projects__facet-form',
          industrySelect: '[name="industry"]',
          resultText: '#projects__results',
          grid: '#projects__grid',
          loadMoreBtn: '#projects__load-more',
        };
        this.classes = {};

        this.formEl = this.querySelector(this.selectors.form);
        this.industrySelectEl = this.formEl.querySelector(this.selectors.industrySelect);
        this.resultTextEl = this.querySelector(this.selectors.resultText);
        this.gridEl = this.querySelector(this.selectors.grid);
        this.loadMoreBtnEl = this.querySelector(this.selectors.loadMoreBtn);
        this.thumbnailSize = this.querySelector('#projects__thubnails_size');

        this.itemsPerPage = parseInt(this.dataset.itemsPerPage);
        this.resultText = this.dataset.resultText;

        this.formEl.addEventListener('change', this.onFilterChange.bind(this));
        this.loadMoreBtnEl.addEventListener('click', this.onLoadMoreClick.bind(this));
      }

      connectedCallback() {
        this.setDefautlIndustry();
        this.init();
      }

      setDefautlIndustry() {
        const url = new URL(window.location.href);
        const industry = url.searchParams.get('industry');

        if (industry) {
          const isValid = Array.from(this.industrySelectEl.options).some((option) => option.value === industry);

          if (isValid) {
            this.industrySelectEl.value = industry;
            this.industrySelectEl.dispatchEvent(new Event('change'));
          }
        }
      }

      onFilterChange() {
        this.init();
      }

      get allItems() {
        return (this._allItems =
          this._allItems || JSON.parse(this.querySelector('[type="application/json"]').textContent));
      }

      get cardPlaceholderHtml() {
        return (this._cardPlaceholderHtml = this._cardPlaceholderHtml || this.cardPlaceholderTempate());
      }

      get noResultEl() {
        return (this._noResultEl = this._noResultEl || this.querySelector('#projects__no-results'));
      }

      cardPlaceholderTempate() {
        const template = this.querySelector('template');
        const templateContent = template.content.cloneNode(true);

        const container = document.createElement('div');
        container.appendChild(templateContent);

        let html = container.innerHTML;
        container.remove();

        return html;
      }

      serializeJSON(formData) {
        const data = {};

        formData.forEach((value, key) => {
          const keys = key.split('[').map((k) => k.replace(']', '')); // Split keys and remove brackets
          let current = data;

          // Loop through keys and build nested structure
          keys.forEach((k, index) => {
            if (index === keys.length - 1) {
              // Set value at the deepest level
              current[k] = value;
            } else {
              // Create nested object if it doesn't exist
              current[k] = current[k] || {};
              current = current[k];
            }
          });
        });

        return data;
      }

      prepareData() {
        this.activeFilters = this.serializeJSON(new FormData(this.formEl));

        if (Shopify.designMode) {
          // Shopify added this hidden input to our form. It make the filter wrong.
          delete this.activeFilters?.oseid;
        }

        this.items = this.filterProjects(this.allItems, this.activeFilters);
        this.items = this.sortByOrder(this.items);
        this.totalItems = this.items.length;
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.currentPage = 1;
      }

      filterProjects(projects, filters) {
        return projects.filter((project) => {
          return Object.entries(filters).every(([key, value]) => {
            if (value === '') return true; // Skip filtering for empty string.
            return project[key]?.id === value;
          });
        });
      }

      sortByOrder(data) {
        return data.sort((a, b) => {
          const sortA = a.sort_order;
          const sortB = b.sort_order;

          if (sortA === '' && sortB !== '') {
            return 1;
          }
          if (sortA !== '' && sortB === '') {
            return -1;
          }
          if (sortA === '' && sortB === '') {
            return 0;
          }
          // If both are not empty, sort numerically.
          return parseInt(sortA) - parseInt(sortB);
        });
      }

      init() {
        this.prepareData();
        this.reset(); // Run after data prepare.
        this.updateGrid();
      }

      reset() {
        this.gridEl.innerHTML = '';

        if (this.totalItems > 0) {
          this.noResultEl.classList.add('!hidden');
        } else {
          this.noResultEl.classList.remove('!hidden');
        }
      }

      updateGrid() {
        if (this.totalItems > 0) {
          let output = '';

          const startIndex = (this.currentPage - 1) * this.itemsPerPage;
          const endIndex = Math.min(startIndex + this.itemsPerPage - 1, this.totalItems - 1);

          for (let i = startIndex; i <= endIndex; i++) {
            output += this.getItemHtml(this.items[i]);
          }

          this.gridEl.insertAdjacentHTML('beforeend', output);
        }

        this.checkLoadMoreBtnVisible();
        this.updateResultText();
      }

      getShopifyImageUrl(url, options = {}) {
        try {
          if (typeof url !== 'string' || url === '') {
            console.log('Invalid image url', url);
          }

          const { width, height } = options;

          if (!width && !height) {
            // Do nothing if no width or height is specified.
            return url;
          }

          let modifiedUrl = url;

          // Add query parameters based on the options provided.
          const separator = url.includes('?') ? '&' : '?';
          const params = new URLSearchParams();

          if (width) params.append('width', Math.floor(width));
          if (height) params.append('height', Math.floor(height));

          // Append parameters to the URL if any were added.
          if (Array.from(params).length > 0) {
            modifiedUrl += `${separator}${params.toString()}`;
          }

          return modifiedUrl;
        } catch (e) {
          console.log(e);

          return false;
        }
      }

      getShopifyImage(url, options = {}) {
        const {
          width,
          height,
          loading = '',
          classes = '',
          widths = [],
          sizes = '',
          alt = '',
          style = '',
          widthAttr,
          heightAttr,
          isImageLazy = true,
        } = options;

        const imageUrl = this.getShopifyImageUrl(url, options);
        if (!imageUrl) {
          return '';
        }

        // Generate srcset by mapping each width in the array to a URL
        const srcset = Array.isArray(widths)
          ? widths.map((w) => `${this.getShopifyImageUrl(url, { width: w })} ${w}w`).join(', ')
          : '';

        return `
    <img src="${imageUrl}" 
      ${isImageLazy ? `is="image-lazy"` : ''}
      ${widthAttr ? `width="${widthAttr}"` : ''} 
      ${heightAttr ? `height="${heightAttr}"` : ''}
      ${loading ? `loading="${loading}"` : ''}
      ${classes ? `class="${classes}"` : ''}
      ${srcset ? `srcset="${srcset}"` : ''}
      ${sizes ? `sizes="${sizes}"` : ''}
      ${style ? `style="${style}"` : ''}
      ${alt ? `alt="${alt}"` : ''}>`;
      }

      getPlaceholderImage() {
        return '<svg class="placeholder-svg w-full h-full hover-scale-up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>';
      }

      getItemHtml(project) {
        const thumbnail = project.media
          ? this.getShopifyImage(project.media, {
              widths: [165, 355, 450, 535, 710, 900, 1070],
              sizes: this.thumbnailSize.textContent,
              widthAttr: 461,
              heightAttr: 338,
            })
          : this.getPlaceholderImage();
        let cardHtml = this.cardPlaceholderHtml;

        // Replace placeholder
        const replacements = {
          '%%thumbnail%%': thumbnail,
          '%%name%%': project.name,
          '%%url%%': project.url,
          '%%sign%%': project.sign.label,
        };

        for (const [key, value] of Object.entries(replacements)) {
          cardHtml = cardHtml.replaceAll(key, value);
        }

        return cardHtml;
      }

      updateResultText() {
        if (this.totalItems == 0) {
          this.resultTextEl.classList.add('!hidden');
          return;
        }

        const displayedItems = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        this.resultTextEl.classList.remove('!hidden');
        let text = this.resultText.replace('%%1%%', displayedItems);
        text = text.replace('%%2%%', this.totalItems);

        this.resultTextEl.textContent = text;
      }

      checkLoadMoreBtnVisible() {
        if (this.currentPage < this.totalPages) {
          this.loadMoreBtnEl.classList.remove('!hidden');
          this.loadMoreBtnEl.querySelector('.btn').removeAttribute('disabled');
        } else {
          this.loadMoreBtnEl.classList.add('!hidden');
          this.loadMoreBtnEl.querySelector('.btn').setAttribute('disabled', true);
        }
      }

      onLoadMoreClick() {
        this.currentPage++;
        this.updateGrid();
      }
    }
  );
}
